<ng-container *transloco="let t">

  @if (!isFullScreen) {
  <div [@listEnter]="listAnimState" class="d-lg-none">
    @for (tableDataRow of tableData; track tableDataRow.id!) {
    <div class="px-3"
         [@rowUpdate]="animState(tableDataRow)"
         [class.row-highlight]="tableDataRow.updated"
         [class.row-move]="!!tableDataRow.delta"
         [class.row-new]="tableDataRow.isNew"
         [ngStyle]="{'--translate-value': tableDataRow.delta + '%'}">
        <app-results-table-mobile-list-item
          [competitor]="tableDataRow.competitorResults"
          [isRound]="isRoundRace ?? false"
          [category]="category"
          [gender]="gender"
          [measurementType]="measurementType"
          [firstCompetitorResults]="firstCompetitorResults"
          [isAdmin]="false"
          [isFullScreen]="isFullScreen"
          [race]="race"
          [isLast]="$last"
          (onOpenDetails)="openDetailsModal(tableDataRow.competitorResults)"
        ></app-results-table-mobile-list-item>
      </div>
    }
  </div>
  }
  <div [class.d-lg-block]="!isFullScreen" [class.d-none]="!isFullScreen">
    <div class="grid-table-box" [class.dark-theme]="isDarkMode" [class.full-screen]="isFullScreen" [class.split-view]="isFullScreen && fullScreenMode === FullScreenMode.SPLIT">
      <div class="grid-table" [class.is-carousel]="isCarousel" [class.no-carousel]="!isCarousel" [class]="'cols-' + columnCount">

        <!-- Header -->
        <div class="grid-header" [ngClass]="{ 'is-carousel': isCarousel, 'no-carousel': !isCarousel }">
          <div class="grid-cell cell-center"><p class="">{{t('live.results.events.results.table.rank')}}</p></div>
          <div class="grid-cell"><p class="">{{t('competitor.table.bib')}}</p></div>
          <div class="grid-cell"><p class="">{{t('app.common.competitor')}}</p></div>
          @if (showCategoryCol) {
          <div class="grid-cell"><p class="">{{t('app.common.category.short')}}</p></div>
          }
          @if (showTeamCol) {
          <div class="grid-cell no-wrap-text"><p class="">{{t('competitor.table.club.team')}}</p></div>
          }
          <div class="grid-cell cell-center"><p class="">{{t('live.results.events.results.table.time')}}</p></div>
          @if (showGapCol) {
            <div class="grid-cell"><p>{{t('live.results.events.results.table.gap')}}</p></div>
          }
          @if (showLapCol) {
            <div class="grid-cell">
              <p class="">{{t('live.results.events.results.table.laps')}}</p>
            </div>
          }
          @if (showDistanceCol) {
          <div class="grid-cell"><p class="">{{t('competitor.table.distance')}}</p></div>
          }
        </div>

        <!-- ══ NON-CAROUSEL: fixed top 3 + 5-second paged rows ══ -->
        @if (!isCarousel) {

        <!-- Fixed top 3 (always visible) -->
        <div [@listEnter]="listAnimState" class="list-enter-host">
          @for (liveResult of fixedRows; let idx = $index; track liveResult.id!) {
        <div class="grid-row"
             [@rowUpdate]="animState(liveResult)"
             [class.row-highlight]="liveResult.updated"
             [class.row-move]="!!liveResult.delta"
             [class.row-new]="liveResult.isNew"
             [ngStyle]="{'--translate-value': liveResult.delta + '%'}"
             [class.result-border-bottom]="idx === 2">
          <ng-container [ngTemplateOutlet]="cellsTemplate"
                        [ngTemplateOutletContext]="{ $implicit: liveResult }"></ng-container>
        </div>
        }
        </div>

        <!-- Paged rows (stage-filtered, 7 at a time, 5 s per page) -->
        @if (pagedRows.length > 0) {
        <div [@listEnter]="listAnimState" class="list-enter-host">
          @for (liveResult of pagedRows; track liveResult.id!) {
          <div class="grid-row"
               [@rowUpdate]="animState(liveResult)"
               [class.row-highlight]="liveResult.updated"
               [class.row-move]="!!liveResult.delta"
               [class.row-new]="liveResult.isNew"
               [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
                  <ng-container [ngTemplateOutlet]="cellsTemplate"
                                [ngTemplateOutletContext]="{ $implicit: liveResult }"></ng-container>
                </div>
          }
        </div>
        }

        }

        @if (isCarousel) {
        <!-- Fixed top 3 -->
        <div [@listEnter]="listAnimState">
          @for (liveResult of fixedRows; let idx = $index; track liveResult.id!) {
        <div class="grid-row"
             [@rowUpdate]="animState(liveResult)"
             [class.row-highlight]="liveResult.updated"
             [class.row-move]="!!liveResult.delta"
             [class.row-new]="liveResult.isNew"
             [ngStyle]="{'--translate-value': liveResult.delta + '%'}"
             [class.result-border-bottom]="idx === 2">
          <ng-container [ngTemplateOutlet]="cellsTemplate"
                        [ngTemplateOutletContext]="{ $implicit: liveResult }"></ng-container>
        </div>
        }
        </div>

        @if (pages.length > 0) {
        <ngb-carousel
                [interval]="carouselInterval"
                [wrap]="wrap"
                [keyboard]="false"
                [pauseOnHover]="pauseOnHover"
                [pauseOnFocus]="pauseOnFocus"
                [showNavigationIndicators]="false"
                [showNavigationArrows]="false"
        >
          @for (page of pages; let p = $index; track p) {
          <ng-template ngbSlide [id]="pageId(p)">
            <div [@listEnter]="listAnimState">
              @for (liveResult of page; let localIdx = $index; track liveResult.id!) {
          <div class="grid-row"
               [@rowUpdate]="animState(liveResult)"
               [class.row-highlight]="liveResult.updated"
               [class.row-move]="!!liveResult.delta"
               [class.row-new]="liveResult.isNew"
               [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
            <ng-container [ngTemplateOutlet]="cellsTemplate"
                          [ngTemplateOutletContext]="{ $implicit: liveResult }"></ng-container>
          </div>
          }
          </div>
        </ng-template>
          }
        </ngb-carousel>
        }
        }

      </div>

      <div class="d-flex justify-content-center align-items-center loader-holder">
        <div [class.scale-loader]="isFullScreen">
          @if (!isFinished && !isCarousel) {
          <app-three-dots [isDarkMode]="isDarkMode"/>
          }
        </div>
      </div>
    </div>
  </div>

  <ng-template #cellsTemplate let-liveResult>

    <div class="grid-cell cell-center">
      <p>{{liveResult?.competitorResults | rank:category:gender:measurementType}}</p>
    </div>
    <div class="grid-cell">
      <div class="start-number-badge cursor-pointer"
           [class.dark-theme]="isFullScreen"
           (click)="openDetailsModal(liveResult.competitorResults)">
        {{liveResult.competitorResults?.startNumber ?? ""}}
        <span class="ps-1">
          <img src="assets/icons/icons-alt/search-list-02.svg" alt="Open details" class="icon"/>
        </span>
      </div>
    </div>

    <div class="grid-cell ls-5 cell-name no-wrap-text">
      <div class="d-flex align-items-center gap-1">
          @if (liveResult.competitorResults?.country) {
          <div class="d-flex align-items-center gap-1">
                  <div class="flag-wrapper">
                    <i [class]="'ioc-' + liveResult.competitorResults?.country"></i>
                  </div>
          </div>
          }
        <div class="d-flex align-items-baseline">
          <p class="mb-0 no-wrap-text">{{
            ((liveResult.competitorResults?.firstName ?? "") | uppercase) + " " +
            ((liveResult.competitorResults?.lastName ?? "") | uppercase)
            }}
          </p>
        </div>
      </div>
    </div>

    @if (showCategoryCol) {
    <div class="grid-cell">
      <p>{{liveResult.competitorResults?.categoryLabel ?? ""}}</p>
      </div>
    }

    @if (showTeamCol) {
    <div class="grid-cell no-wrap-text">
        <p>{{liveResult.competitorResults?.club ?? ""}}</p>
    </div>
    }


    <div class="grid-cell cell-center">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <p>{{liveResult.competitorResults?.competitorResultsDetail | resultsTotalTime:measurementType:raceSettings?.measurementPrecisionType}}</p>
        @if (!isRoundRace && liveResult.competitorResults?.competitorResultsDetail?.ltpCompetitorStageDetail) {
        <p class="no-wrap-text lighter-text">{{liveResult.competitorResults?.competitorResultsDetail?.ltpCompetitorStageDetail | waypointNameByWaypointId}}</p>
        }
      </div>
    </div>

    @if (showGapCol) {
    <div class="grid-cell">
      <p>{{liveResult.competitorResults?.competitorResultsDetail | resultsGapTime:firstCompetitorResults?.competitorResultsDetail:measurementType:raceSettings?.measurementPrecisionType}}</p>
    </div>
    }

    @if (showLapCol) {
    <div class="grid-cell">
      <p>{{liveResult.competitorResults?.competitorResultsDetail | nmControlPointsOrLaps:isRoundRace}}</p>
    </div>
    }

    @if (showDistanceCol) {
    <div class="grid-cell">
      <p>{{liveResult.competitorResults?.competitorResultsDetail?.distance | raceLengthFormat:undefined:"m"}}</p>
      </div>
    }

  </ng-template>

</ng-container>